import { REQUEST_ROLES, RESPONSE_ROLES, REQUEST_ROLES_FAILURE, E } from "../actions/rolesActions";

import { states } from "./queriesStates";

const initialState = {
  rolesDataState: states.NOT_REQUESTED,
  roles: [],
  errors: null,
};

const rolesReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ROLES:
      return Object.assign({}, state, {
        rolesDataState: states.REQUEST,
        roles: [],
      });
    case RESPONSE_ROLES:
      return Object.assign({}, state, {
        rolesDataState: states.READY,
        roles: action.data.roles,
      });
    case REQUEST_ROLES_FAILURE:
      return Object.assign({}, state, {
        rolesDataState: states.FAILURE,
        errors: action.errors,
      });

    default:
      return state;
  }
};

export default rolesReducer;
